import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { patternValidator } from '../../../pattern-validator';
import { Router } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	@Input() requesting;
	@Input() serverError;

	@Output() formEmitter: EventEmitter<any> = new EventEmitter<any>();

	loginFormSubmitted = false;
	loginForm: FormGroup;

	emailError = false;
	passwordError = false;
	showPasswordArgs = false;

	submitted = false;

	destroyed: ReplaySubject<boolean> = new ReplaySubject(1);

	constructor(private formBuilder: FormBuilder, private router: Router) {
		this.loginForm = this.createForm();
	}

	ngOnInit() {
		this.loginForm.valueChanges
			.pipe(takeUntil(this.destroyed))
			.subscribe(() =>
				this.submitted ? this.clearErrors() : (this.submitted = false)
			);
	}

	get loginFormControls() {
		return this.loginForm.controls;
	}

	ngOnDestroy() {
		this.destroyed.next(true);
		this.destroyed.complete();
	}

	get emailInvalid() {
		const control = this.loginForm.get('email');

		return !!control.errors;
	}

	get passwordInvalid() {
		const control = this.loginForm.get('password');

		return !!control.errors;
	}

	emitForm() {
		this.loginFormSubmitted = true;
		if (this.loginForm.valid) {
			this.formEmitter.emit(this.loginForm.value);
		} else {
			if (this.emailInvalid) {
				this.emailError = true;
			}
			if (this.passwordInvalid) {
				this.passwordError = true;
			}
		}
		this.submitted = true;
	}

	clearErrors() {
		this.emailError = false;
		this.passwordError = false;
	}

	createForm() {
		return this.formBuilder.group({
			email: [
				'',
				[
					Validators.required,
					patternValidator(
						/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
					)
				]
			],
			password: ['', Validators.required]
		});
	}

	showPassword() {
		this.showPasswordArgs = !this.showPasswordArgs;
	}
}
